<template>
  <div class="form-list">
    <el-form
      ref="form"
      class="form"
      :rules="rules"
      :model="teacher"
      label-position="left"
      label-width="160px"
    >
      <el-form-item label="昵称" prop="nickname">
        <el-input v-model="teacher.nickname" maxlength="16" @input="handleInput"/>
        <span v-if="teachers.length" class="teacher-list-tip danger-color">
          检测到以下相似昵称的老师，若存在该老师，请勿重复提交申请，直接在列表页添加至您的门店
        </span>
        <v-avatar-nickname
          class="teacher-item"
          v-for="v in teachers"
          :key="v.id"
          :value="v.avatar"
          :nickname="v.nickname"
          :is-center="true"
          :nickname-overflow="true"
          :link-page-name="RouteConfig.teacherList.name"
          :link-page-query="{ keyword: v.nickname, store_id: 0 }"
          :avatar-size="50"
        />
      </el-form-item>

      <v-image-upload
        v-model="teacher.avatar"
        label="头像"
        prefix="teacher"
        ratio="1:1"
        propName="avatar"
      />
      <el-form-item v-if="isAdministrator" label="所属门店" prop="store_ids">
        <v-select-store
          v-model="teacher.store_ids"
          :multiple="true"
          :is-location-limit="true"
          width="100%"
          placeholder="请选择门店"
        />
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input v-model="teacher.phone" min="0" type="number" placeholder="请输入老师的手机号"/>
      </el-form-item>
      <el-form-item label="不在小程序列表展示">
        <el-switch v-model="teacher.is_hide_in_list" :active-value="1" :inactive-value="0"/>

        <el-alert
          title="此功能默认关闭，开启后，小程序的首页老师列表、筛选列表均不展示"
          type="info"
          show-icon
          :closable="false"
        />
      </el-form-item>
      <el-form-item label="企业微信号">
        <el-input v-model="teacher.we_chat" />
      </el-form-item>
      <el-form-item label="微博号">
        <el-input v-model="teacher.micro_blog" />
      </el-form-item>
      <el-form-item label="美拍号">
        <el-input v-model="teacher.mei_pai" />
      </el-form-item>

      <el-form-item label="个人简介">
        <el-input
          type="textarea"
          :autosize="{ minRows: 4 }"
          placeholder="请输入老师的个人简介"
          v-model="teacher.brief"
          maxlength="1000"
          show-word-limit
        />
      </el-form-item>

<!--      <el-form-item
        label="2021作品收录个数"
        prop="video_count"
      >
        <v-input-number
          placeholder="请输入2021年作品收录个数"
          v-model="teacher.video_count"
        />
      </el-form-item>

      <el-form-item
        label="2021作品总播放量"
        prop="view_count"
      >
        <v-input-number
          placeholder="请输入2021年作品总播放量"
          v-model="teacher.view_count"
        />
      </el-form-item>-->

<!--      <el-form-item label="2021最受欢迎作品名称" prop="video_name">
        <el-input v-model="teacher.video_name" maxlength="255" placeholder="请输入2021年最受欢迎作品名称" />
      </el-form-item>

      <el-form-item label="2021参加过的活动名称" prop="dynamic_name">
        <el-input v-model="teacher.dynamic_name" maxlength="255" placeholder="请输入2021年参加过的活动名称" />
      </el-form-item>

      <el-form-item label="2021学生祝福语">
        <el-input
          type="textarea"
          :autosize="{ minRows: 4 }"
          placeholder="请输入2021年学生想对老师说的祝福语"
          v-model="teacher.blessing"
          maxlength="1000"
          show-word-limit
        />
      </el-form-item>-->

      <el-form-item>
        <el-button type="primary" @click="handleSubmit" :loading="isSaving">
          {{ isAdministrator ? '立即添加' : '申请添加' }}
        </el-button>
        <el-button @click="RouteConfig.teacherList.back">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import RouteConfig from "@/router/config";
import { mapGetters } from 'vuex';
import { index as getTeachers, store } from '@/api/teacher';
import { store as storeApply } from '@/api/teacher-add-apply';
import { index } from '@/api/store';
import { debounce } from "@/utils";

export default {
  name: RouteConfig.teacherAdd.name,
  data: () => ({
    RouteConfig,
    isSaving: false,
    teacher: {
      nickname: '',
      phone: '',
      we_chat: '',
      micro_blog: '',
      mei_pai: '',
      avatar: '',
      brief: '',
      store_ids: [],
      is_hide_in_list: 0,

      /*video_count: 0,
      view_count: 0,
      video_name: '',
      dynamic_name: '',
      blessing: '',*/
    },
    stores: [],
    teachers: [],
    rules: {
      nickname: [{ required: true, message: '请输入老师昵称', trigger: 'change' }],
      avatar: [{ required: true, message: '请上传老师头像', trigger: 'change' }],
      store_ids: [{ required: true, message: '请选择所属门店', trigger: 'change' }],
      phone: [{ required: true, message: '请输入老师手机号', trigger: 'change' }],
    },
  }),
  computed: {
    ...mapGetters([
      'isAdministrator',
    ]),
  },
  methods: {
    async getStores() {
      const { isError, data } = await index({ is_only_name: 1 });
      if (isError) return;

      this.stores = data;
    },
    handleInput: debounce(async function() {
      if (!this.teacher.nickname) {
        this.teachers = [];
        return;
      }
      const { isError, data } = await getTeachers({ keyword: this.teacher.nickname });
      if (isError) return;

      this.teachers = data.list;
    }),
    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        const postData = { ...this.teacher };
        const post = this.isAdministrator ? store : storeApply;
        this.isSaving = true;
        const { isError } = await post(postData);
        this.isSaving = false;
        if (isError) return;

        this.isAdministrator ? RouteConfig.teacherList.push() : RouteConfig.teacherAddApplyList.push();
      });
    },
  },
  beforeMount() {
    this.getStores();
  },
};
</script>

<style src="./add.css" scoped/>
